import { Box, Flex, Text, Button } from '@chakra-ui/react';

export const EmptyBlueprint = ({ onStartFromScratch = () => {} }) => {
  return (
    <Flex height="100%" alignItems="center" justifyContent="center" px="24px">
      <Box width="500px" textAlign="center" mt="-100px">
        <Text fontWeight="semiBold" fontSize="18px">
          Oops! We couldn't find what you're looking for.
        </Text>
        <Text fontWeight="medium" fontSize="14px" color="secondary-700" mt="12px">
          Try using filters to narrow down the blueprint.
        </Text>
        <Button mt="12px" onClick={onStartFromScratch}>
          Create from scratch
        </Button>
      </Box>
    </Flex>
  );
};
